import { Nullable } from '@mews/std';

interface NewRelicLoggerConfig {
    insertKey: string;
    logEndpoint: string;
}
export type NullableNewRelicLoggerConfig = Nullable<NewRelicLoggerConfig> | undefined | null;
interface NewRelicReporterConfig {
    eventEndpoint: string;
    insertKey: string;
}
export type NullableNewRelicReporterConfig = Nullable<NewRelicReporterConfig> | undefined | null;

export const isNewRelicLoggerActive = (
    newRelicConfig: NullableNewRelicLoggerConfig
): newRelicConfig is NewRelicLoggerConfig => newRelicConfig?.logEndpoint != null && newRelicConfig?.insertKey != null;

export const isNewRelicReporterActive = (
    newRelicConfig: NullableNewRelicReporterConfig
): newRelicConfig is NewRelicReporterConfig =>
    newRelicConfig?.eventEndpoint != null && newRelicConfig?.insertKey != null;
